import React from "react";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./art.css";

//import Popup from 'reactjs-popup';
//import { isElementOfType } from "react-dom/test-utils";

class Art extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            isOpen: false,
            originalVisibility: false,
        };
        this.showModal=this.showModal.bind(this);
        this.hideModal=this.hideModal.bind(this);
        this.toggleImage=this.toggleImage.bind(this);
    };

    showModal() {
        this.setState({
            isOpen: true
        })
    };

    hideModal() {
        this.setState({
            isOpen: false
        })
    };

    toggleImage() {
        let toggle = !this.state.originalVisibility;
        this.setState({originalVisibility: toggle});
    }

    render() {

        let woodArrayKey = this.props.eachArt.woodListKey;
        let woodArrayValue = this.props.eachArt.woodListValue;        
        let displayedImage = this.state.originalVisibility ? <img id="originalPhoto" src={`${this.props.eachArt.srcOriginal}`} width="100%" alt="Art" onClick={this.toggleImage} /> : <img id="photo" src={`${this.props.eachArt.src}`} width="100%" alt="Art original" onClick={this.toggleImage} />;

        return(
            <div id="artElement" className='artElement'>
                <img className="galleryImage" src={`${this.props.eachArt.src}`} alt="gallery art" onClick={this.showModal}></img>
                        <Modal show={this.state.isOpen} onHide={this.hideModal} dialogClassName={"primaryModal"}>
                            <Modal.Header onClick={this.hideModal} className="close">X</Modal.Header>
                            <Modal.Body className="modalBodyStyle">
                                
                                {displayedImage}
                                <span id="toggleText">Click image to show the original photo</span>
                                <div>
                                <span id="dimensions">
                                    Dimensions: {this.props.eachArt.dimensions}
                                </span>
                                <span id="price">
                                    Price: {this.props.eachArt.price}
                                </span>
                                </div>
                                <div id="woodsUsed">
                                    <span>Woods Used:</span>
                                </div>
                                <div className="woodKeysAndValues">
                                    <div id="woodKeys">
                                        {woodArrayKey}
                                    </div>
                                    <div id="woodValues">
                                        {woodArrayValue}
                                    </div>
                                    <br></br><br></br>
                                </div>
                            </Modal.Body>
                        </Modal>
                <div id="artCaption">{this.props.eachArt.name}</div>
                <div id="sold">{this.props.eachArt.sold}</div>
                <br></br>
            </div>
        );
    }
}

export default Art;